export default __webpack_public_path__ + "static/Tek_Phase_Pistol-ae369b6198e3a1745c824caae21fdd93.png";